import React from 'react';

import Button from '~/core/atoms/Buttons/Button';

export interface ChatQuestionButtonProps {
  text: string;
  onClick: () => void;
}

const ChatQuestionButton: React.FC<ChatQuestionButtonProps> = ({ text, onClick }) => {
  return (
    <Button
      variant="secondary"
      className="rounded-lg bg-white/70 text-base font-medium text-slate-900 transition-colors duration-200 hover:bg-white/20"
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

export default ChatQuestionButton;
